import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/vercel/path4/node_modules/gatsby-theme-notes/src/components/layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>{`gatsby-theme-mono`}</h1>
    <p>{`A `}<a parentName="p" {...{
        "href": "https://theme-ui.com"
      }}>{`Theme UI`}</a>{` preset theme for `}<a parentName="p" {...{
        "href": "https://gatsbyjs.org"
      }}>{`Gatsby`}</a></p>
    <pre><code parentName="pre" {...{
        "className": "language-sh"
      }}>{`npm i gatsby-theme-mono
`}</code></pre>
    <h2>{`Usage`}</h2>
    <p>{`This theme is built with composition in mind and can be used as the basis for a custom theme or to adjust the styles in other themes.`}</p>
    <h3>{`Composed with other themes`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`// gatsby-config.js
module.exports = {
  plugins: [
    'gatsby-theme-blog',
    'gatsby-theme-mono',
  ]
}
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`// gatsby-config.js
module.exports = {
  plugins: [
    'gatsby-theme-notes',
    'gatsby-theme-mono',
  ]
}
`}</code></pre>
    <h3>{`As a base theme`}</h3>
    <p>{`The styles in this theme can be used as a starting point for custom themes.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`// gatsby-config.js
module.exports = {
  plugins: [
    'gatsby-theme-mono',
    'gatsby-plugin-theme-ui',
  ]
}
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`// src/gatsby-plugin-theme-ui/index.js
import baseTheme from 'gatsby-theme-mono'

export default {
  ...baseTheme,
  // add custom styles to override the base theme
}
`}</code></pre>
    <p>{`See the `}<a parentName="p" {...{
        "href": "https://theme-ui.com"
      }}>{`Theme UI`}</a>{` docs for more info on how to use the styles in your custom theme.`}</p>
    <p>{`MIT License`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      